








import Vue from 'vue';
import { SortParams } from './Table.types';

export default Vue.extend({
  name: 'Header',
  props: {
    sortField: {
      type: String,
    },
    sortAsc: {
      type: Boolean,
    },
  },
  mounted() {
    // Listen for events from HeaderCell children
    this.$on('_clickHeaderCell', ({ field }: { field: string }) => {
      const asc = (field === this.sortField) ? !this.sortAsc : this.sortAsc;
      this.$emit('updateSort', { field, asc } as SortParams);
    });
  },
});
